import { Price } from '@kanda-libs/ks-design-library';
import useJobFinanceFinanceSubsidy from './useJobFinanceFinanceSubsidy';

const JobFinanceFinanceSubsidy: React.FunctionComponent = function () {
  const { loan, deposit, subsidy, depositSubsidy, payout, isCashDeposit } =
    useJobFinanceFinanceSubsidy();
  return (
    <>
      <div className="col-span-2 border-b border-neutral-300 my-2" />
      <p className="my-auto">Loan:</p>
      <Price
        amount={loan}
        color="neutral-700"
        poundsClassName="text-16-20-em"
        centsClassName="text-16-20-em"
        className="ml-auto"
      />
      {!isCashDeposit && deposit && (
        <>
          <p className="my-auto">Deposit:</p>
          <Price
            amount={deposit}
            color="neutral-700"
            poundsClassName="text-16-20-em"
            centsClassName="text-16-20-em"
            className="ml-auto"
          />
        </>
      )}
      <p className="my-auto whitespace-nowrap">Loan Subsidy:</p>
      <div className="flex flex-row justify-end my-auto">
        <p className="text-neutral-800 my-auto">-</p>
        <Price
          amount={subsidy}
          color="neutral-700"
          poundsClassName="text-16-20-em"
          centsClassName="text-16-20-em"
          className="ml-auto"
        />
      </div>
      {depositSubsidy && (
        <>
          <p className="my-auto whitespace-nowrap">Deposit Subsidy (1%):</p>
          <div className="flex flex-row justify-end my-auto">
            <p className="text-neutral-800 my-auto">-</p>
            <Price
              amount={depositSubsidy}
              color="neutral-700"
              poundsClassName="text-16-20-em"
              centsClassName="text-16-20-em"
              className="ml-auto"
            />
          </div>
        </>
      )}
      <div className="col-span-2 border-b border-neutral-300 my-2" />
      <p className="my-auto">Payout:</p>
      <Price
        amount={payout}
        color="purple-500"
        poundsClassName="text-16-20-em"
        centsClassName="text-16-20-em"
        className="ml-auto"
      />
    </>
  );
};

export default JobFinanceFinanceSubsidy;
